import * as React from 'react';

import { Button, Typography } from '@coursera/cds-core';
import { Box } from '@coursera/coursera-ui';

import Modal from 'bundles/ui/components/Modal';

import _t from 'i18n!nls/third-party-auth';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};

const UnlinkConfirmModal = ({ onCancel, onConfirm }: Props) => (
  <Modal className="rc-UnlinkConfirmModal" trackingName="unlinkConfrimationModal" onRequestClose={onCancel}>
    <Box flexDirection="column" alignItems="start">
      <Typography className="m-b-1" variant="h2" component="h4">
        {_t('Are you sure you want to unlink from Zoom?')}
      </Typography>

      <div className="m-b-3">{_t('You can always link again later.')}</div>
    </Box>

    <Box justifyContent="end">
      <Button variant="secondary" onClick={onCancel} style={{ marginRight: 12 }} data-test-id="cancel-btn">
        {_t('Cancel')}
      </Button>
      <Button variant="primary" onClick={onConfirm} data-test-id="unlink-btn">
        {_t('Unlink')}
      </Button>
    </Box>
  </Modal>
);

export default UnlinkConfirmModal;
